//@ts-nocheck
import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import auth from '../../shared/mobx/auth-state';
import settingsState from '../../shared/mobx/settings-state';
import { usePaddle } from '../../hooks/usePaddle';

const PaddleDebugger: React.FC = () => {

  const paddle = usePaddle(
    {
      environment: settingsState.paddleEnviroment?.environment || 'sandbox',
      token: settingsState.paddleEnviroment?.token || ''
    },
    () => console.log('Checkout completed'),
    () => console.log('Checkout closed')
  );

  useEffect(() => {
    const paddleEnv = settingsState.paddleEnviroment;
    const token = paddleEnv?.token;
    
    console.log('=== PADDLE DEBUGGER DEBUG ===');
    console.log('Paddle Environment Object:', paddleEnv);
    console.log('Token Value:', token);
    console.log('Token Type:', typeof token);
    console.log('Token Length:', token?.length);
    console.log('Has Token (!!token):', !!token);
    console.log('=============================');
    
    const info = {
      paddleInstance: !!paddle,
      paddleType: typeof paddle,
      paddleKeys: paddle ? Object.keys(paddle) : [],
      hasCustomerPortal: paddle && typeof paddle.CustomerPortal === 'object',
      customerPortalKeys: paddle?.CustomerPortal ? Object.keys(paddle.CustomerPortal) : [],
      customerId: auth.currentUser?.customer_id || 'Not available',
      userEmail: auth.currentUser?.email || 'Not available',
      environment: settingsState.paddleEnviroment?.environment || 'sandbox',
      hasToken: !!settingsState.paddleEnviroment?.token,
      tokenValue: settingsState.paddleEnviroment?.token, // Add this to see the actual token value
      timestamp: new Date().toISOString()
    };
    console.log('Paddle Debug Info:', info);
    console.log('Full Paddle Instance:', paddle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paddle]);

  return null;
};

export default observer(PaddleDebugger);
